export function getView(selected) {
  return !(
    selected.trigger_type === 'pre' &&
    selected.action_type === 'check_requirements'
  )
}
